import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_EquipmentSkeleton = _resolveComponent("EquipmentSkeleton")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_fab = _resolveComponent("ion-fab")!
  const _component_ContentSidebarWrapper = _resolveComponent("ContentSidebarWrapper")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { color: "primary" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  (!_ctx.loading)
                    ? (_openBlock(), _createBlock(_component_ion_back_button, {
                        key: 0,
                        text: _ctx.$t('report_sheets.top_bar.back_to_steps'),
                        "default-href": `/report-sheets/${_ctx.$route.params.uuidReport}/employees`
                      }, null, 8, ["text", "default-href"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('report_sheets.top_bar.title')) + " : " + _toDisplayString(_ctx.employee?.report_sheet?.title ?? _ctx.$t('report_sheets.top_bar.loading')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.$style['sub-header'])
          }, _toDisplayString(_ctx.$t('report_sheets.employee_item.sub_top_bar_title')) + " : " + _toDisplayString(_ctx.employee?.firstname) + " " + _toDisplayString(_ctx.employee?.lastname), 3))
        : _createCommentVNode("", true),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ContentSidebarWrapper, { side: "left" }, {
            content: _withCtx(() => [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_EquipmentSkeleton)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          disabled: _ctx.fieldDisabled,
                          label: _ctx.$t('report_sheets.employee_item.form.labels.activity'),
                          placeholder: "Enter data",
                          modelValue: _ctx.employee.activity,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.employee.activity) = $event))
                        }, null, 8, ["disabled", "label", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          disabled: _ctx.fieldDisabled,
                          label: _ctx.$t('report_sheets.employee_item.form.labels.comment'),
                          placeholder: "Enter data",
                          modelValue: _ctx.employee.comment,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.employee.comment) = $event))
                        }, null, 8, ["disabled", "label", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          disabled: _ctx.fieldDisabled,
                          type: "number",
                          label: _ctx.$t('report_sheets.employee_item.form.labels.travel'),
                          placeholder: "Enter data",
                          modelValue: _ctx.employee.travel,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.employee.travel) = $event))
                        }, null, 8, ["disabled", "label", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          disabled: _ctx.fieldDisabled,
                          type: "number",
                          label: _ctx.$t('report_sheets.employee_item.form.labels.mobility'),
                          placeholder: "Enter data",
                          modelValue: _ctx.employee.mobility,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.employee.mobility) = $event))
                        }, null, 8, ["disabled", "label", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_select, {
                          disabled: _ctx.fieldDisabled,
                          label: _ctx.$t('report_sheets.employee_item.form.labels.mobility_code'),
                          placeholder: _ctx.$t('report_sheets.employee_item.form.placeholder.select'),
                          modelValue: _ctx.employee.mobility_code,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.employee.mobility_code) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportSheetMobilities, (mobility) => {
                              return (_openBlock(), _createBlock(_component_ion_select_option, {
                                key: mobility.uuid,
                                value: mobility.uuid
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(mobility.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["disabled", "label", "placeholder", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_select, {
                          disabled: _ctx.fieldDisabled,
                          label: _ctx.$t('report_sheets.employee_item.form.labels.other_service'),
                          placeholder: _ctx.$t('report_sheets.employee_item.form.placeholder.select'),
                          modelValue: _ctx.employee.services_other,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.employee.services_other) = $event)),
                          onIonChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleChange($event)))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportSheetOtherServices, (otherService) => {
                              return (_openBlock(), _createBlock(_component_ion_select_option, {
                                key: otherService.uuid,
                                value: otherService.uuid
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(otherService.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["disabled", "label", "placeholder", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          disabled: _ctx.fieldDisabled,
                          label: _ctx.$t('report_sheets.employee_item.form.labels.percent_other_service'),
                          modelValue: _ctx.employee.services_other_percentage_cost,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.employee.services_other_percentage_cost) = $event)),
                          type: "number",
                          onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.calculateTotalHoursWorked()))
                        }, null, 8, ["disabled", "label", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.$style['custom-label-input-time-wrapper'])
                        }, [
                          _createElementVNode("label", {
                            class: _normalizeClass(_ctx.$style['custom-label-input-time'])
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('report_sheets.employee_item.form.labels.start_at')), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "time",
                              disabled: _ctx.fieldDisabled,
                              placeholder: "00:00",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.employee.start_at) = $event)),
                              onInput: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.calculateTotalHoursWorked && _ctx.calculateTotalHoursWorked(...args)))
                            }, null, 40, _hoisted_3), [
                              [_vModelText, _ctx.employee.start_at]
                            ])
                          ], 2),
                          _createElementVNode("label", {
                            class: _normalizeClass(_ctx.$style['custom-label-input-time'])
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('report_sheets.employee_item.form.labels.end_at')), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "time",
                              disabled: _ctx.fieldDisabled,
                              placeholder: "00:00",
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.employee.end_at) = $event)),
                              onInput: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.calculateTotalHoursWorked && _ctx.calculateTotalHoursWorked(...args)))
                            }, null, 40, _hoisted_4), [
                              [_vModelText, _ctx.employee.end_at]
                            ])
                          ], 2),
                          _createElementVNode("label", {
                            class: _normalizeClass(_ctx.$style['custom-label-input-time'])
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('report_sheets.employee_item.form.labels.total_rest')), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "time",
                              disabled: _ctx.fieldDisabled,
                              placeholder: "00:00",
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.employee.rest_time) = $event)),
                              onInput: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.calculateTotalHoursWorked && _ctx.calculateTotalHoursWorked(...args)))
                            }, null, 40, _hoisted_5), [
                              [_vModelText, _ctx.employee.rest_time]
                            ])
                          ], 2)
                        ], 2)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          disabled: true,
                          label: _ctx.$t('report_sheets.employee_item.form.labels.total_hour'),
                          modelValue: _ctx.employee.total_hours,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.employee.total_hours) = $event))
                        }, null, 8, ["label", "modelValue"])
                      ]),
                      _: 1
                    }),
                    (_ctx.user.rights?.includes('report_sheets.manager'))
                      ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_input, {
                              disabled: _ctx.fieldDisabled,
                              label: _ctx.$t('report_sheets.employee_item.form.labels.hour_cost'),
                              modelValue: _ctx.employee.hourly_cost,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.employee.hourly_cost) = $event)),
                              type: "number",
                              onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.calculateTotalDailyCost()))
                            }, null, 8, ["disabled", "label", "modelValue"]),
                            _createVNode(_component_ion_input, {
                              disabled: true,
                              label: _ctx.$t('report_sheets.employee_item.form.labels.total_cost'),
                              modelValue: _ctx.employee.total_cost,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.employee.total_cost) = $event))
                            }, null, 8, ["label", "modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.employee.report_sheet?.employees_step_validated || _ctx.userCanForceEdit())
                      ? (_openBlock(), _createBlock(_component_ion_fab, {
                          key: 1,
                          slot: "fixed",
                          vertical: "bottom",
                          horizontal: "end"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_fab_button, {
                              color: "primary",
                              onClick: _ctx.presentActionSheet
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, { icon: _ctx.caretUp }, null, 8, ["icon"])
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}